export default __webpack_public_path__ + "static/media/DesktopWalletPayment.49d33da4.svg";